import { currencyToNumber } from "./currencyToNumber.mjs";
function localCurrencyPurchaseFromFacebookData(data) {
  return {
    platform: "fb",
    payload: data.developerPayload,
    id: data.paymentID,
    productID: data.productID,
    timestamp: data.purchaseTime,
    token: data.purchaseToken,
    signedRequest: data.signedRequest,
    returnCode: data.returnCode,
    // passthrough
    currency: data.currency,
    // passthrough
    amount: data.amount,
    // passthrough
    rawData: data
  };
}
function purchaseFromLocalCurrencyPurchase(localCurrencyPurchase, product, convertCurrency) {
  const currencyCode = (product == null ? void 0 : product.currencyCode) || "";
  const revenueGrossLocal = currencyToNumber((product == null ? void 0 : product.price) || "");
  const converted = convertCurrency({
    amount: revenueGrossLocal,
    fromCurrency: currencyCode,
    toCurrency: "USD"
  });
  return {
    ...localCurrencyPurchase,
    revenueGrossLocal,
    revenueGrossUSD: converted == null ? void 0 : converted.result,
    dollarToLocalRate: converted == null ? void 0 : converted.exchangeRate
  };
}
export {
  localCurrencyPurchaseFromFacebookData,
  purchaseFromLocalCurrencyPurchase
};
